
// Validate the form
const data = {
    user: '',
    mail: '',
    comment: ''
}

const user = document.querySelector('#user');
const mail = document.querySelector('#mail');
const comment = document.querySelector('#comment');
const form = document.querySelector('.form__content');

user.addEventListener('input', readText);
mail.addEventListener('input', readText);
comment.addEventListener('input', readText);


form.addEventListener('submit', function(e){
    e.preventDefault();

    const { user, mail, comment } = data;

    if(user === '' || mail === '' || comment === ''){
        showAlert('Todos los campos son obligatorios', 'error');

        return;
    }

    showAlert('El envío se ha realizado correctamente');
})

function readText(e){
    data[e.target.id] = e.target.value;
}

function showAlert(message, error = null){
    const alert = document.createElement('P');
    alert.textContent = message;

    if(error){
        alert.classList.add('error');
    } else {
        alert.classList.add('correct');
    }

    form.appendChild(alert);

    setTimeout(()=>{
        alert.remove();
    }, 5000);
}